import { service } from '@ember/service';
import Component from '@glimmer/component';
import type GenericResourceModel from 'garaje/models/generic-resource';
import type LiveMapService from 'garaje/services/live-map';
import type { ResourceAmenity } from 'garaje/services/live-map';
import type StateService from 'garaje/services/state';
import compact from 'lodash/compact';

interface ResourcePopupAmenitiesListArgs {
  resource: GenericResourceModel | undefined;
}

export default class ResourcePopupAmenitiesList extends Component<ResourcePopupAmenitiesListArgs> {
  @service declare state: StateService;
  @service declare liveMap: LiveMapService;

  get amenities(): ResourceAmenity[] {
    const amenityIds = (this.args.resource?.amenities || []).map((a) => a.id);
    const amenities = compact(amenityIds.map((id) => this.liveMap.getAmenityById(id)));
    return amenities;
  }
}
